export default "__VITE_ASSET__glyAGfBs__"